import { normalizeDeployEnvironment } from "./deploy-env.js";
export const PILOT_SURFACE_CLASSES = {
    "api.agencyAuth": "SHIP",
    "api.health": "SHIP",
    "api.businessProfileReadiness": "SHIP",
    "api.runs": "SHIP",
    "api.exportRun": "SHIP",
    "api.studio": "SHIP",
    "api.studioProjects": "SHIP",
    "api.studioPreview": "SHIP",
    "api.clientLinks": "SHIP",
    "api.clientIntake": "SHIP",
    "api.studioIntake": "SHIP",
    "api.reports": "SHIP",
    "api.launchProof": "SHIP",
    "api.departureKit": "SHIP",
    "api.publicScan": "HIDE",
    "api.agencyEditorPatch": "FLAG",
    "api.salesRoom": "FLAG",
    "api.clientSafePatch": "FLAG",
    "api.agencyPublicReportClaim": "FLAG",
    "api.agencyFixKit": "FLAG",
    "api.launchCertificate": "FLAG",
    "api.websiteOwnershipRecord": "FLAG",
    "api.agencyRelaunchPreview": "FLAG",
    "api.agencyBatchAudit": "FLAG",
    "api.agencyImportDraft": "FLAG",
    "api.agencyImportConfirmation": "FLAG",
    "api.agencyExternalSiteProof": "FLAG",
    "api.agencyExternalReadiness": "FLAG",
    "api.agencyExternalProofFixKit": "FLAG",
    "api.agencyExternalProofSalesRoom": "FLAG",
    "api.agencyExternalAfterFixProof": "FLAG",
    "api.governance": "ADMIN_ONLY",
    "api.recordCenter": "ADMIN_ONLY",
    "api.publicConversionEvents": "ADMIN_ONLY",
    "api.agencyPilotOutreach": "ADMIN_ONLY",
    "studio.view.today": "SHIP",
    "studio.view.projects": "SHIP",
    "studio.view.project": "SHIP",
    "studio.view.scans": "FLAG",
    "studio.view.settings": "FLAG",
    "studio.view.inbox": "ADMIN_ONLY",
    "studio.view.portfolio": "SHIP",
    "studio.richnessPanel": "HIDE",
    "client.safePatch": "FLAG",
    "client.governancePanel": "FLAG",
    "client.externalProofPanels": "FLAG",
    "client.launchCertificateSummary": "SHIP",
    "client.handoff": "SHIP",
    "client.reports": "SHIP",
    "client.intake": "SHIP",
    "client.previewApproval": "SHIP",
    "public.home": "HIDE",
    "public.for-agencies": "HIDE",
    "public.ai-readiness": "HIDE",
    "public.fix-kit-sample": "HIDE",
    "public.launch-certificate-sample": "HIDE",
    "public.website-ownership-checklist": "HIDE",
    "public.departure-kit": "HIDE",
    "public.agency-relaunch-campaign": "HIDE",
    "public.apply": "HIDE",
    "public.legal-terms": "HIDE",
    "public.legal-privacy": "HIDE",
    "public.report": "FLAG",
    "public.agency-report-claim": "FLAG",
    "public.launch-certificate-verify": "FLAG",
};
export function resolvePilotExposureMode(input = {}) {
    const raw = (input.deployEnv ?? input.nodeEnv ?? "development").trim().toLowerCase();
    const deployEnv = normalizeDeployEnvironment(raw);
    if (raw === "pilot" || raw === "controlled-pilot" || raw === "t1-pilot" || deployEnv === "staging") {
        return "pilot";
    }
    if (deployEnv === "production")
        return "production";
    return "development";
}
export function parseEnabledPilotFlags(raw) {
    return new Set((raw ?? "").split(",").map((value) => value.trim()).filter(Boolean));
}
export function isPilotFeatureExplicitlyEnabled(surfaceId, flags) {
    return flags.has(surfaceId) || flags.has(surfaceId.replace(/[^a-zA-Z0-9]+/g, "_"));
}
export function canExposePilotSurface(surfaceId, actor, input = {}) {
    const surfaceClass = PILOT_SURFACE_CLASSES[surfaceId];
    const mode = resolvePilotExposureMode(input);
    const flags = parseEnabledPilotFlags(input.explicitFlags);
    const adminActor = actor === "admin" || actor === "internal";
    if (surfaceClass === "SHIP")
        return { surfaceId, surfaceClass, mode, enabled: true, reason: "ship" };
    if (surfaceClass === "HIDE") {
        const enabled = mode === "development";
        return { surfaceId, surfaceClass, mode, enabled, reason: enabled ? "flag_enabled" : "hidden" };
    }
    if (surfaceClass === "ADMIN_ONLY") {
        return { surfaceId, surfaceClass, mode, enabled: adminActor, reason: adminActor ? "admin_allowed" : "admin_denied" };
    }
    const enabled = mode === "development" || isPilotFeatureExplicitlyEnabled(surfaceId, flags);
    return { surfaceId, surfaceClass, mode, enabled, reason: enabled ? "flag_enabled" : "flag_disabled" };
}
//# sourceMappingURL=pilot-exposure.js.map